const BreadcrumbTiers = ["full", "collapseMiddle", "collapseAll"] as const;

export type BreadcrumbTier = (typeof BreadcrumbTiers)[number];

export interface BreadcrumbTierCandidate {
    tier: BreadcrumbTier;
    width: number;
}

export function getApplicableTiers(crumbCount: number) {
    return BreadcrumbTiers.filter(tier => {
        if (tier === "collapseMiddle") {
            return crumbCount >= 3;
        }

        if (tier === "collapseAll") {
            return crumbCount >= 2;
        }

        return true;
    });
}

export function selectBreadcrumbTier(candidates: readonly BreadcrumbTierCandidate[], availableWidth: number): BreadcrumbTier {
    if (availableWidth <= 0) {
        return candidates.at(0)?.tier ?? "full";
    }

    return candidates.find(candidate => candidate.width <= availableWidth)?.tier ?? candidates.at(-1)?.tier ?? "full";
}
